import useUser, { PrivateUser } from "../../../hooks/useUser";
import { with_comma } from "../../../util/comma";
import React, { useContext } from "react";
import { actionContext } from "../../../apps/page";
import api from "../../../util/api";
import Flex from "../../layout/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faC, faP, faUser } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert"
import Btn from "../../layout/Btn";

export function Userinfo({ user, mutateUser }: { user: PrivateUser, mutateUser: any }) {

    function PointExchangeCash() {
        api(`/api/user/exchange-point`, { method: 'POST' })
            .catch(e => swal({
                text: '포인트전환 오류가 발생했습니다.',
                icon: "error"
            }))
    }
    return (
        <div className={'user-btn'}>
            <div className={'money-layout'}>
                <div>
                    {/* <span className={'i-user'}>
                        <FontAwesomeIcon icon={faUser} />
                    </span> */}
                    <span>{user.nickname}</span>
                </div>
                |
                <div className={'user-amount'}>
                    {/* <span className={'i-cash'}>
                        <FontAwesomeIcon icon={faC} />
                    </span> */}
                    <span>{with_comma(user.money)} 원</span>
                </div>
                {
                    user.point > 0
                        ? <div className={'user-amount'}>
                            <div className={'user-amount'}>
                                {/* <span className={'i-point'}>
                                    <FontAwesomeIcon icon={faP} />
                                </span> */}
                                <span>{with_comma(user.point)}</span>
                            </div>
                            <Btn className="red"
                                onClick={PointExchangeCash}
                            >포인트 전환</Btn>
                        </div>
                        : <></>
                }
                <div className="btn-wrap">
                    <Btn className="blue" onClick={e => {
                        api(`/api/user/logout`)
                            .then(e => mutateUser(undefined))
                            .catch(e => swal({
                                text: '로그아웃 실패',
                                icon: "error"
                            }))
                        // window.location.reload()
                    }}>로그아웃</Btn>
                </div>
            </div>
        </div>
    )
}

export function UserBtn() {
    const { SetLoginPop, SetRegisterPop } = useContext(actionContext)
    return (
        <>
            <div className="btn-wrap">
                <Btn className="light-blue" onClick={SetLoginPop}>로그인</Btn>
                <Btn className="blue" onClick={SetRegisterPop}>회원가입</Btn>
            </div>
        </>
    )
}